"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { GroupsRequestParams } from "@/entities/IGroup";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { Mutable, NonNullableNotRequired } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import GroupCard from "./card/GroupCard";
import GroupsListSearch from "./search/GroupsListSearch";
import CommonInfiniteScrollWrapper from "@/components/utils/infinite-scroll/CommonInfiniteScrollWrapper";
import { useDebounce } from "react-use";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
const REQUEST_SIZE = 20;
export default function GroupsList(t0) {
  const $ = _c(42);
  const {
    filters,
    showIdentitySearch,
    showCreateNewGroupButton,
    showMyGroupsButton,
    onCreateNewGroup,
    setGroupName,
    setAuthorIdentity,
    onMyGroups
  } = t0;
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  let t1;
  if ($[0] !== filters) {
    t1 = () => setDebouncedFilters(filters);
    $[0] = filters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== filters) {
    t2 = [filters];
    $[2] = filters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useDebounce(t1, 200, t2);
  let t3;
  if ($[4] !== debouncedFilters) {
    t3 = {
      queryKey: [QueryKey.GROUPS, debouncedFilters],
      queryFn: async t4 => {
        const {
          pageParam
        } = t4;
        const params = {};
        if (debouncedFilters.group_name) {
          params.group_name = debouncedFilters.group_name;
        }
        if (debouncedFilters.author_identity) {
          params.author_identity = debouncedFilters.author_identity;
        }
        if (pageParam) {
          params.created_at_less_than = `${pageParam}`;
        }
        return await commonApiFetch({
          endpoint: "groups",
          params
        });
      },
      initialPageParam: null,
      getNextPageParam: _temp,
      placeholderData: keepPreviousData
    };
    $[4] = debouncedFilters;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  } = useInfiniteQuery(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const [groups, setGroups] = useState(t4);
  let t5;
  if ($[7] !== data?.pages) {
    t5 = () => setGroups(data?.pages?.flat() ?? []);
    $[7] = data?.pages;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== data) {
    t6 = [data];
    $[9] = data;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== fetchNextPage || $[12] !== groups.length || $[13] !== hasNextPage || $[14] !== isFetching || $[15] !== isFetchingNextPage || $[16] !== status) {
    t7 = state => {
      if (groups.length < REQUEST_SIZE) {
        return;
      }
      if (!state) {
        return;
      }
      if (status === "pending") {
        return;
      }
      if (isFetching) {
        return;
      }
      if (isFetchingNextPage) {
        return;
      }
      if (!hasNextPage) {
        return;
      }
      fetchNextPage();
    };
    $[11] = fetchNextPage;
    $[12] = groups.length;
    $[13] = hasNextPage;
    $[14] = isFetching;
    $[15] = isFetchingNextPage;
    $[16] = status;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const onBottomIntersection = t7;
  const [activeGroupIdVoteAll, setActiveGroupIdVoteAll] = useState(null);
  let t8;
  if ($[18] !== filters.author_identity || $[19] !== filters.group_name || $[20] !== onCreateNewGroup || $[21] !== onMyGroups || $[22] !== setAuthorIdentity || $[23] !== setGroupName || $[24] !== showCreateNewGroupButton || $[25] !== showIdentitySearch || $[26] !== showMyGroupsButton) {
    t8 = <GroupsListSearch identity={filters.author_identity} groupName={filters.group_name} showIdentitySearch={showIdentitySearch} showCreateNewGroupButton={showCreateNewGroupButton} showMyGroupsButton={showMyGroupsButton} setIdentity={setAuthorIdentity} setGroupName={setGroupName} onCreateNewGroup={onCreateNewGroup} onMyGroups={onMyGroups} />;
    $[18] = filters.author_identity;
    $[19] = filters.group_name;
    $[20] = onCreateNewGroup;
    $[21] = onMyGroups;
    $[22] = setAuthorIdentity;
    $[23] = setGroupName;
    $[24] = showCreateNewGroupButton;
    $[25] = showIdentitySearch;
    $[26] = showMyGroupsButton;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== activeGroupIdVoteAll || $[29] !== groups) {
    let t10;
    if ($[31] !== activeGroupIdVoteAll) {
      t10 = group => <GroupCard key={group.id} group={group} activeGroupIdVoteAll={activeGroupIdVoteAll} setActiveGroupIdVoteAll={setActiveGroupIdVoteAll} />;
      $[31] = activeGroupIdVoteAll;
      $[32] = t10;
    } else {
      t10 = $[32];
    }
    t9 = groups.map(t10);
    $[28] = activeGroupIdVoteAll;
    $[29] = groups;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[33] !== t9) {
    t10 = <div className="tw-mt-6 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4 lg:tw-gap-5">{t9}</div>;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== isFetching || $[36] !== onBottomIntersection || $[37] !== t10) {
    t11 = <CommonInfiniteScrollWrapper loading={isFetching} onBottomIntersection={onBottomIntersection}>{t10}</CommonInfiniteScrollWrapper>;
    $[35] = isFetching;
    $[36] = onBottomIntersection;
    $[37] = t10;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t11 || $[40] !== t8) {
    t12 = <>{t8}{t11}</>;
    $[39] = t11;
    $[40] = t8;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  return t12;
}
function _temp(lastPage) {
  return lastPage.at(-1)?.created_at ?? null;
}